import { useState } from 'react';
import { Link } from 'react-router-dom';
import api from '../lib/api';
import Button from '../ui/Button';
import Input from '../ui/Input';
import AuthLayout from '../shell/AuthLayout';

// HD-4: Portal profile on src/ui (DESIGN rev 2.1 §3.3). Same request as before.
export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState('');

  async function handleSubmit(e) {
    e.preventDefault();
    setErr('');
    setLoading(true);
    try {
      await api.post('/api/auth/forgot-password', { email });
      setSent(true);
    } catch {
      setErr('The reset link did not send. Check the connection and try again.');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout>
      {sent ? (
        <>
          <h1 className="ui-auth__title">Check your email</h1>
          <p className="ui-auth__lede">If {email} has an account, a reset link is on its way. The link expires in 1 hour.</p>
          <Link className="ui-auth__link" to="/login">Back to sign in</Link>
        </>
      ) : (
        <>
          <h1 className="ui-auth__title">Reset your password</h1>
          <p className="ui-auth__lede">Enter your email and we send you a link to set a new password.</p>
          <form className="ui-auth__form" onSubmit={handleSubmit}>
            <Input label="Email" type="email" placeholder="you@journeyviral.com" value={email} onChange={e => setEmail(e.target.value)} required autoFocus autoComplete="email" />
            {err && <p className="ui-auth__alert" role="alert">{err}</p>}
            <Button type="submit" variant="primary" portal loading={loading}>Send reset link</Button>
          </form>
          <Link className="ui-auth__link" to="/login">Back to sign in</Link>
        </>
      )}
    </AuthLayout>
  );
}
